import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { LogOut, LayoutDashboard } from "lucide-react";

export const Navbar = () => {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    const isLogged = !!(user && user._id);

    const handleLogout = async () => {
        await logout();
        nav("/");
    };

    return (
        <header className="sticky top-0 z-50 px-4 pt-4">
            <nav
                className="glass mx-auto flex max-w-6xl items-center justify-between rounded-full px-5 py-3"
                data-testid="navbar"
            >
                <Logo size="sm" />
                <div className="hidden items-center gap-8 md:flex">
                    <a href="/#explore" data-testid="nav-explore" className="text-sm text-moss hover:text-ink transition-colors">Explore</a>
                    <a href="/#how" data-testid="nav-how" className="text-sm text-moss hover:text-ink transition-colors">How it works</a>
                    <a href="/#popular" data-testid="nav-popular" className="text-sm text-moss hover:text-ink transition-colors">Destinations</a>
                    <Link to="/trips/new" data-testid="nav-plan-trip" className="text-sm text-moss hover:text-ink transition-colors">Plan a trip</Link>
                </div>
                <div className="flex items-center gap-2">
                    {isLogged ? (
                        <>
                            <Link to="/dashboard" data-testid="nav-dashboard" className="btn-ghost hidden sm:inline-flex">
                                <LayoutDashboard size={16} className="mr-2" /> Dashboard
                            </Link>
                            <button
                                onClick={handleLogout}
                                data-testid="nav-logout"
                                className="btn-primary"
                                title={user.email}
                            >
                                <LogOut size={16} className="mr-2" /> Logout
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" data-testid="nav-login" className="btn-ghost hidden sm:inline-flex">Login</Link>
                            <Link to="/register" data-testid="nav-register" className="btn-primary">Get started</Link>
                        </>
                    )}
                </div>
            </nav>
        </header>
    );
};

export default Navbar;
